import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";
import type { StoreYard } from "../types";

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

export async function fetchStoreYards(): Promise<StoreYard[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/inventory/store-yards`);
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<StoreYard[]>;
}

export async function createStoreYardApi(input: {
  name: string;
  notes?: string;
  address?: string;
}): Promise<StoreYard> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/inventory/store-yards`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: input.name, notes: input.notes ?? "", address: input.address ?? "" }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<StoreYard>;
}

export async function updateStoreYardApi(
  id: string,
  patch: Partial<
    Pick<
      StoreYard,
      | "name"
      | "notes"
      | "address"
      | "scopeType"
      | "districtKeys"
      | "mandalRefs"
      | "villageRefs"
      | "zoneIds"
      | "sortOrder"
    >
  >,
): Promise<StoreYard> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/inventory/store-yards/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<StoreYard>;
}

export async function deleteStoreYardApi(id: string): Promise<void> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/inventory/store-yards/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (!res.ok && res.status !== 204) throw new Error(await parseError(res));
}

export async function reorderStoreYards(orderedIds: string[]): Promise<StoreYard[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/inventory/store-yards/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderedIds }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<StoreYard[]>;
}
